<template>
  <div class="editor-bar" v-show="visible" :style="barPosition" ref="editorBar">
    <div class="editor-button" style="display:flex; flex-direction:column; align-items:center " @click="setActiveMenu('line')">
      <svg style="width:24px;height:24px" viewBox="0 0 24 24" v-if="selectedObjectProperties.textColor">
        <path fill="#3e4c59" d="M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z" />
      </svg>
      <svg style="width:24px;height:24px;" viewBox="0 0 24 24" v-else>
        <path fill="#3e4c59" d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
      </svg>
      <div style="height:12px; width:80%; margin-bottom: 3px; border-radius:2px" :style="{backgroundColor: selectedObjectProperties.textColor || selectedObjectProperties.stroke}"></div>
      <color-palette :showAbove="showMenusAbove" v-if="activeMenu==='line'" @click="false" :colors="lineColors" @colorPicked="pickedColor"></color-palette>
    </div>
    
    <div v-if="selectedObjectProperties.fillColor || selectedObjectProperties.fill" class="editor-button"  style="display:flex; flex-direction:column; align-items:center"  @click="setActiveMenu('fill')">
      <svg style="height:24px;" viewBox="0 0 20 20">
        <path fill="#3e4c59" d="M19,11.5C19,11.5 17,13.67 17,15A2,2 0 0,0 19,17A2,2 0 0,0 21,15C21,13.67 19,11.5 19,11.5M5.21,10L10,5.21L14.79,10M16.56,8.94L7.62,0L6.21,1.41L8.59,3.79L3.44,8.94C2.85,9.5 2.85,10.47 3.44,11.06L8.94,16.56C9.23,16.85 9.62,17 10,17C10.38,17 10.77,16.85 11.06,16.56L16.56,11.06C17.15,10.47 17.15,9.5 16.56,8.94Z" />
      </svg>
      <div style="height:10px; width:80%; margin-bottom: 3px; border-radius:2px; box-sizing: border-box; border-size: 1px; border-style: solid" :style="{backgroundColor: selectedObjectProperties.fill, borderColor: selectedObjectProperties.fill === 'transparent' ? '#ccc' : selectedObjectProperties.fill}"></div>
      <color-palette :showAbove="showMenusAbove" :shownone="true" v-if="activeMenu==='fill'" :colors="fillColors" @click="false"  @colorPicked="fillPicked"></color-palette>
    </div>

    <!-- FONT CONTROLS -->
    <div v-if="selectedObjectProperties.textColor">
      <div class="editor-button" :class="{ 'selected': selectedObjectProperties.fontWeight === 'bold' }" @click="updateProperty('fontWeight', selectedObjectProperties.fontWeight === 'bold' ? '' : 'bold')">
        <svg viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M13.5,15.5H10V12.5H13.5A1.5,1.5 0 0,1 15,14A1.5,1.5 0 0,1 13.5,15.5M10,6.5H13A1.5,1.5 0 0,1 14.5,8A1.5,1.5 0 0,1 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z" />
        </svg>
      </div>
      <div class="editor-button" :class="{ 'selected': selectedObjectProperties.underline }" @click="updateProperty('underline', !selectedObjectProperties.underline)">
        <svg viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M5,21H19V19H5V21M12,17A6,6 0 0,0 18,11V3H15.5V11A3.5,3.5 0 0,1 12,14.5A3.5,3.5 0 0,1 8.5,11V3H6V11A6,6 0 0,0 12,17Z" />
        </svg>
      </div>

      <div class="editor-button" :class="{ 'selected': selectedObjectProperties.linethrough }" @click="updateProperty('linethrough', !selectedObjectProperties.linethrough)">
        <svg viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z" />
        </svg>
      </div>

      <div class="editor-button" :class="{ 'selected': selectedObjectProperties.fontStyle === 'italic' }" @click="updateProperty('fontStyle', selectedObjectProperties.fontStyle === 'italic' ? '' : 'italic')">
        <svg viewBox="0 0 24 24">
          <path fill="#3e4c59" d="M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z" />
        </svg>
      </div>
    </div>

    <div v-if="showLineThickness">
      <div class="editor-button"  @click="setActiveMenu('thickness')"   style="display:flex; flex-direction:column; align-items:center">
        <svg style="width:100%; height: 100%" viewBox="0 0 24 24" v-if="this.selectedObjectProperties.strokeWidth === 2">
          <path d="m 4.57,18.73 a 0.5,0.5 0 0 0 0,0.7 0.5,0.5 0 0 0 0.71,0 L 19.42,5.28 a 0.5,0.5 0 0 0 0,-0.71 0.5,0.5 0 0 0 -0.71,0 l 0,0 L 4.58,18.72 a 0.5,0.5 0 0 0 0,0 z" />
        </svg>
        <svg style="width:100%; height: 100%" viewBox="0 0 24 24" v-if="this.selectedObjectProperties.strokeWidth === 4">
          <path d="m 4.58,18 a 1,1 0 0 0 0,1.41 1,1 0 0 0 1.41,0 L 19.42,6 a 1,1 0 0 0 0,-1.41 1,1 0 0 0 -1.41,0 z" />
        </svg>
        <svg style="width:100%; height: 100%" viewBox="0 0 24 24" v-if="this.selectedObjectProperties.strokeWidth === 6">
          <path d="m 4.5753788,17.303301 a 1.5,1.5 0 0 0 0,2.12132 1.5,1.5 0 0 0 2.1213203,0 L 19.424621,6.6966991 a 1.5,1.5 0 0 0 0,-2.1213203 1.5,1.5 0 0 0 -2.12132,0 z" />
        </svg>
        <svg style="width:100%; height: 100%" viewBox="0 0 24 24" v-if="this.selectedObjectProperties.strokeWidth === 8">
          <path d="m 4.54,16.63 a 2,2 0 0 0 0,2.79 2,2 0 0 0 2.83,0 L 19.42,7.4 a 2,2 0 0 0 0,-2.83 2,2 0 0 0 -2.83,0 l -0.03535,0.035355 -12,12 a 2,2 0 0 0 0,0 z" />
        </svg>
        <div class="thickness-select" v-if="activeMenu==='thickness'" :style="{top: showMenusAbove ? '' : '45px', bottom: showMenusAbove ? '64px' : ''}">
          <div class="editor-button"  @click.stop="updateProperty('strokeWidth', 2)">
            <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
              <path d="m 4.57,18.73 a 0.5,0.5 0 0 0 0,0.7 0.5,0.5 0 0 0 0.71,0 L 19.42,5.28 a 0.5,0.5 0 0 0 0,-0.71 0.5,0.5 0 0 0 -0.71,0 l 0,0 L 4.58,18.72 a 0.5,0.5 0 0 0 0,0 z" />
            </svg>
          </div>
          <div class="editor-button"  @click.stop="updateProperty('strokeWidth', 4)">
            <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
              <path d="m 4.58,18 a 1,1 0 0 0 0,1.41 1,1 0 0 0 1.41,0 L 19.42,6 a 1,1 0 0 0 0,-1.41 1,1 0 0 0 -1.41,0 z" />
            </svg>
          </div>
          <div class="editor-button"  @click.stop="updateProperty('strokeWidth', 6)">
            <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
              <path d="m 4.5753788,17.303301 a 1.5,1.5 0 0 0 0,2.12132 1.5,1.5 0 0 0 2.1213203,0 L 19.424621,6.6966991 a 1.5,1.5 0 0 0 0,-2.1213203 1.5,1.5 0 0 0 -2.12132,0 z" />
            </svg>
          </div>
          <div class="editor-button"  @click.stop="updateProperty('strokeWidth', 8)">
            <svg style="width:100%; height: 100%" viewBox="0 0 24 24">
              <path d="m 4.54,16.63 a 2,2 0 0 0 0,2.79 2,2 0 0 0 2.83,0 L 19.42,7.4 a 2,2 0 0 0 0,-2.83 2,2 0 0 0 -2.83,0 l -0.03535,0.035355 -12,12 a 2,2 0 0 0 0,0 z" />
            </svg>
          </div>
        </div>
      </div>
      
    </div>

    <div class="splitter"></div>

    <div class="editor-button"  @click="removeObject">
      <svg  style="width:100%; height: 100%" viewBox="0 0 24 24">
        <path fill="#3e4c59" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
      </svg>
    </div>
    <!-- <div class="splitter"></div>
    <div class="editor-button"  @click="setActiveMenu('extra')">
      <svg  style="width:100%; height: 100%" class="editor-button" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
      </svg>
      <div class="menu" ref="menu" :style="menuPosition" v-if="activeMenu==='extra'">
        <ul>
          <li>Bring To Top</li>  
          <li>Bring To Top</li>  
          <li>Bring To Top</li>  
          <li>Bring To Top</li>  
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
const { getWhiteboard } = require('../whiteboard')
import colorPalette from './color-palette'
let whiteboard

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  props: ['scale'],
  components: {
    colorPalette,
  },
  mounted () {
    whiteboard = getWhiteboard({canvasId: 'annotation-canvas'});
    whiteboard.on('selectionChanged', this.selectionChanged);
    whiteboard.on('objectMoving', this.selectedObjectMove)
  },
  data () {
    return {
      selectedObjectProperties: {},
      selectedObjects: [],
      selectedObject: {},

      activeMenu: '',
      showMenusAbove: false,

      barPosition: { top: 0, left: 0 },
      menuPosition: { top: '61px' },

      fillColors: ['#ebeeb8', '#f2b8ba', '#b9e6b7', '#b9cdf5', '#ccc', '#eee4da', '#ecdded'],
      lineColors: ['#000', '#e6362e', '#3bc123', '#3a75e0','#8d8d8d','#f5831f','#d9e555','#a155a3','#d8d8d8','#a87746','#ffef01','#ff85be']
    }
  },
  methods: {
    selectedObjectMove (event) {
      if (event.moving) {
        this.selectedObjects = []
      } else {
        this.selectionChanged();
      }
    },
    removeObject () {
      whiteboard.removeSelectedObjects();
    },
    async setActiveMenu (menu) {
      this.activeMenu=(this.activeMenu===menu?'':menu)
      await timeout(0)
      if (menu === 'extra') {
        let rect = this.$refs.menu.getBoundingClientRect()
        if ((rect.y + rect.height) > window.innerHeight ) {
          this.menuPosition = {
            top: `-${rect.height + 10}px`,
          }
        } else {
          this.menuPosition = {
            top: `61px`,
          }
        }
      }
    },
    updateProperty (property, value) {
      this.selectedObjectProperties[property] = value
      whiteboard.setSelectedObjectProperties(this.selectedObjectProperties)
      this.activeMenu = ''
    },
    pickedColor (val) {
      if (this.selectedObjectProperties.textColor) {
        this.updateProperty('textColor', val)
      } else {
        this.updateProperty('stroke', val)
      }
    },
    fillPicked (val) {
      this.updateProperty('fill', val)
    },
    toggleFontWeight () {
      updateProperty('fillColor', selectedObjectProperties.fontWeight === 'bold' ? '' : 'Bold')
    },
    async selectionChanged (event) {
      this.selectedObjects = [];
      await timeout(0)
      this.selectedObjects = whiteboard.getSelectedObjectIds() //event.idList;
      await timeout(0)
      if (this.selectedObjects.length === 0) return
      this.selectedObjectProperties = whiteboard.getSelectedObjectProperties();
      this.selectedObject = whiteboard.getObjectById(whiteboard.getSelectedObjectIds()[0])
    }
  },
  watch: {
    async visible (val) {
      if (!val) return
      
      let container = document.getElementsByClassName('transform-container')[0]
      let bounding = container.getBoundingClientRect()
      this.selectedObject = whiteboard.getObjectById(this.selectedObjects[0])

      let top = Math.min(this.selectedObject.aCoords.tl.y, this.selectedObject.aCoords.tr.y, this.selectedObject.aCoords.br.y, this.selectedObject.aCoords.bl.y) - 50
      let bottom = Math.max(this.selectedObject.aCoords.tl.y, this.selectedObject.aCoords.tr.y, this.selectedObject.aCoords.br.y, this.selectedObject.aCoords.bl.y)
      let left = Math.min(this.selectedObject.aCoords.tl.x, this.selectedObject.aCoords.tr.x, this.selectedObject.aCoords.br.x, this.selectedObject.aCoords.bl.x)

      //First pass at default position.
      this.barPosition =  {
        top: Math.max((top * this.scale.y) - 150 + bounding.y, 0) + 'px',
        left: Math.max((left * this.scale.x) + bounding.x, 0) + 'px',
        display: 'none'
      }
      // Wait for DOM updates
      await timeout(0)

      let rect = this.$refs.editorBar.getBoundingClientRect()
      let overlap = ((rect.top + rect.height) > top)
      let rightOverflow = ((rect.x + rect.width) > window.innerWidth - 65 )
      let topOffset = (overlap ? bottom - top + 100: -150)
      let exceedsBottom = overlap && (((bottom * this.scale.y) + rect.height + 50) > bounding.height) 
      this.showMenusAbove = (rect.top > window.innerHeight / 2);
      //Second pass after detecting right overflow and overlap
      this.barPosition = {  
        top: exceedsBottom ? '' : Math.max(((top + topOffset + bounding.y) * this.scale.y) - 30, 0) + 'px',
        right: rightOverflow ? '65px' : '',
        left: rightOverflow ? '' :  Math.max((left * this.scale.x)  + bounding.x, 0) + 'px',
        bottom: exceedsBottom  ? '10px' : '',
      }
    }
  },
  computed: {
    showLineThickness () {
      return (this.selectedObjectProperties && !this.selectedObjectProperties.textColor && this.selectedObjectProperties.strokeWidth !== undefined)
    },
    visible () {
      this.activeMenu = ''
      if (!this.selectedObjects) return false
      return this.selectedObjects.length > 0
    },
  }
}
</script>

<style scoped>
  .menu {
    position: absolute;
    background: #fff;
    white-space: nowrap;
    box-shadow: 0px 3px 20px 0 rgba(0, 0, 0, .12), 0px -3px 10px 0 rgba(0, 0, 0, .12);
    right: 0px;
    z-index: 0;
  }

  .splitter {
    height: 34px;
    background: #ddd;
    width: 2px;
    margin: 0 3px;
  }

  .menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .menu li {
    padding: 8px;
    cursor: pointer;
  }

  .menu li:hover {
    background-color: #e3e7eb
  }

  .editor-bar {
    background-color: white;
    display: flex;
    position: absolute;
    z-index: 999;
    box-shadow: 0px 3px 20px 0 rgba(0, 0, 0, .12), 0px -3px 10px 0 rgba(0, 0, 0, .12);
    padding: 5px;
  }

  .editor-bar div {
    display: flex;
  }

  .editor-button {
    height:30px; 
    width:30px; 
    background-color: #fff; 
    border-radius:3px; 
    display: flex;
    justify-content: center;
    align-content: center;
    cursor:pointer;
    position:relative;
    margin: 2px;
  }

  .editor-button > svg {
    width:30px;
    padding:2px
  }

  .editor-button:hover {
    background-color: #e3e7eb
  }

  .thickness-select{
    position: absolute;
    background: #fff;
    padding: 10px;
    display: flex;
    box-shadow: 0px 3px 20px 0 rgba(0, 0, 0, .12);
  }

  .selected { 
    box-shadow: inset 0 4px 16px 0 rgba(86, 80, 215, 0.3);
  }

</style>